import naja from "naja";
import Ga from '../Ga';

export default class SearchInput {
	constructor() {
		this.outputContainer = document.querySelector('div[data-provide="searchOutputContainer"]');
		this.init();
	}

	init() {
		const parent = this;

		document.querySelectorAll('input[data-provide="searchInput"]:not([data-si-init="1"])').forEach(function (searchInput, key) {
			searchInput.setAttribute('data-si-init', "1");

			// Vytvoření debounced funkce pro vyhledávání produktů
			const debouncedSearchProducts = global.debounce((value) => {
				naja.makeRequest("POST", searchInput.getAttribute("data-handler"), {q: value}, {history: false}).then(results => {
					if (parent.outputContainer) {
						parent.outputContainer.innerHTML = "";

						if (!Array.isArray(results)) {
							return;
						}

						results.forEach((result) => {
							const a = document.createElement("a");
							a.classList.add("prodExample__item");
							a.href = "#";
							a.textContent = result;
							parent.outputContainer.appendChild(a);

							a.addEventListener("click", (e) => {
								(new Ga()).onGuidedSearchClick(a);

								searchInput.value = result.toUpperCase();
								parent.outputContainer.innerHTML = "";
							});
						});
					}
				});
	 		}, 300);

			searchInput.addEventListener("input", (e) => {
				debouncedSearchProducts(e.target.value);
			});

			// Hide examples when clicking outside
			document.addEventListener('click', function(event) {
				if (!searchInput.contains(event.target)) {
					parent.outputContainer.innerHTML = '';
				}
			});
		});
	}

}
